import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
const ResetPasswordModal = ({ show, onHide }) => {
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState({
    hasMinLength: false,
    hasLetter: false,
    hasNumber: false,
  });

  const validatePassword = (pwd) => {
    setNewPassword(pwd);
    setPasswordValidation({
      hasMinLength: pwd.length >= 8,
      hasLetter: /[a-zA-Z]/.test(pwd),
      hasNumber: /[0-9]/.test(pwd),
    });
  };

  const isPasswordValid =
    passwordValidation.hasMinLength &&
    passwordValidation.hasLetter &&
    passwordValidation.hasNumber;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token) {
      setError("Token is required");
      return;
    }

    if (!isPasswordValid) {
      setError("Password must meet all requirements");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      // NOTA: Este componente está obsoleto. El flujo correcto es con SetNewPasswordModal
      setError("Este método ya no está disponible. Por favor usa el flujo de 'Forgot Password' desde el login.");
      setLoading(false);
      return;
    } catch (err) {
      setError(err.message || "Error al resetear contraseña");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setToken("");
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    setSuccess(false);
    setPasswordValidation({
      hasMinLength: false,
      hasLetter: false,
      hasNumber: false,
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {success ? (
          <div className="alert alert-success">
            <strong>Success!</strong>
            <p className="mb-0 mt-2">
              Your password has been reset successfully. You can now login with
              your new password.
            </p>
          </div>
        ) : (
          <>
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <label>
                  <strong>Reset Token</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Paste token from backend console"
                  value={token}
                  onChange={(e) => setToken(e.target.value)}
                  disabled={loading}
                />
                <small className="text-muted">
                  Check the backend console logs for your reset token
                </small>
              </div>

              <div className="form-group mb-3">
                <label>
                  <strong>New Password</strong>
                </label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => validatePassword(e.target.value)}
                  disabled={loading}
                />
                <div className="password-requirements mt-2">
                  <div
                    className={
                      passwordValidation.hasMinLength
                        ? "text-success small"
                        : "text-muted small"
                    }
                  >
                    {passwordValidation.hasMinLength ? "✓" : "○"} Minimum 8
                    characters
                  </div>
                  <div
                    className={
                      passwordValidation.hasLetter
                        ? "text-success small"
                        : "text-muted small"
                    }
                  >
                    {passwordValidation.hasLetter ? "✓" : "○"} At least one
                    letter
                  </div>
                  <div
                    className={
                      passwordValidation.hasNumber
                        ? "text-success small"
                        : "text-muted small"
                    }
                  >
                    {passwordValidation.hasNumber ? "✓" : "○"} At least one
                    number
                  </div>
                </div>
              </div>

              <div className="form-group mb-3">
                <label>
                  <strong>Confirm Password</strong>
                </label>
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={loading}
                />
              </div>
            </form>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {success ? (
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        ) : (
          <>
            <Button variant="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={loading || !isPasswordValid || !token}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ResetPasswordModal;

